/* RetroParlour – geeft het gekozen aantal door aan de koopknop. Blijft kloppen als de kleurkeuze de pagina bijwerkt. */
(() => {
  let quantity = 1;
  const apply = () => {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      let input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.append(input);
      }
      input.value = String(quantity);
    });
  };
  if (!customElements.get('rp-qty-break')) {
    customElements.define('rp-qty-break', class extends HTMLElement {
      connectedCallback() {
        const current = this.querySelector(`input[value="${quantity}"]`);
        if (current) current.checked = true;
        this.addEventListener('change', (event) => {
          quantity = Number(event.target.value) || 1;
          apply();
        });
        apply();
        // Kleurkeuze: de consoles in de rijen krijgen dezelfde kleur
        let thumbs = {};
        try {
          thumbs = JSON.parse(this.dataset.thumbs || '{}');
        } catch (error) {
          thumbs = {};
        }
        const paint = (value) => {
          if (thumbs[value]) this.querySelectorAll('.rp-qb__stack img').forEach((image) => { image.src = thumbs[value]; });
        };
        const form = document.querySelector('variant-picker');
        const checked = form?.querySelector('input:checked');
        if (checked) paint(checked.value);
        this.onPick = (event) => {
          const input = event.target.closest?.('variant-picker input');
          if (input) paint(input.value);
        };
        document.addEventListener('change', this.onPick);
      }
      disconnectedCallback() {
        document.removeEventListener('change', this.onPick);
      }
    });
  }
  // Vlak voor het toevoegen altijd nog even zetten
  document.addEventListener('submit', (event) => {
    if (event.target.matches?.('form[data-type="add-to-cart-form"]')) apply();
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('.add-to-cart-button, .sticky-add-to-cart__button')) apply();
  }, true);
})();
